import E from "../../../tracking/tracking-mixin.vue.js";
import H from "../../../tracking/tracking-constants.js";
import A from "./header-navigation-icon.vue.js";
import V from "./header-navigation-vertical-slide-over.vue.js";
import $ from "./header-subnavigation-vertical.vue.js";
import { resolveComponent as c, resolveDirective as P, withDirectives as N, createElementBlock as s, openBlock as i, withKeys as T, createElementVNode as l, normalizeClass as _, createVNode as d, withCtx as p, createCommentVNode as m, Fragment as h, renderList as f, createBlock as k, toDisplayString as j, mergeProps as B, renderSlot as I, vShow as K } from "vue";
/* empty css                                */
import x from "../../../_virtual/_plugin-vue_export-helper.js";
import W from "../../../utils/mixins/theme/theme.vue.js";
import q from "../../../utils/directives/click-outside.js";
import M from "../../../atoms/text-icon-element/text-icon-element.vue.js";
import R from "../../../atoms/icon-core/icon-core.vue.js";
import z from "../../../molecules/link/link.vue.js";
const y = "search-item", F = {
  name: "DsHeaderNavigationVertical",
  components: {
    DsHeaderNavigationIcon: A,
    DsHeaderNavigationVerticalSlideOver: V,
    DsHeaderSubnavigationVertical: $,
    DsLink: z,
    DsIconCore: R,
    DsTextIconElement: M
  },
  directives: { clickOutsideAwds: q },
  mixins: [W, E],
  props: {
    screen: { type: String, required: !0 },
    primaryItems: { type: Array, default: () => [] },
    secondaryItems: { type: Array, default: () => [] },
    ctaItem: { type: Object, default: null },
    labels: { type: Object, required: !0 }
  },
  emits: ["dropdown-opened", "dropdown-closed", "slide-over-opened", "slide-over-closed", "navigation-opened", "navigation-closed"],
  data: () => ({
    isNavOpen: !1,
    activeSubNavItem: null
  }),
  computed: {
    headerNavigationButtonClassName() {
      switch (!0) {
        case this.isNavOpen:
        case this.theme === "light":
        case this.theme === "grey":
          return "ds-button-link--black";
        case this.theme === "green":
        case this.theme === "dark":
          return "ds-button-link--white";
        default:
          return "";
      }
    }
  },
  watch: {
    activeSubNavItem(e, o) {
      var v;
      const a = e || o, b = a === y ? this.labels.searchLabel : (v = this.primaryItems.find((n) => n.id === a)) == null ? void 0 : v.title;
      this.$emit(`${e ? "dropdown-opened" : "dropdown-closed"}`, { label: b });
    }
  },
  created() {
    this.$options.searchItemId = y, this.$options.tracking = H;
  },
  methods: {
    toggleNav() {
      this.isNavOpen ? this.close() : (this.isNavOpen = !0, setTimeout(() => {
        this.$emit("slide-over-opened");
      }, 200), this.$emit("navigation-opened", { label: this.labels.ariaLabelOpenNavigation }));
    },
    close() {
      this.isNavOpen && (this.activeSubNavItem && (this.activeSubNavItem = null), this.$emit("slide-over-closed"), this.$nextTick(() => {
        this.isNavOpen = !1;
      }), this.$emit("navigation-closed", { label: this.labels.ariaLabelCloseNavigation }));
    },
    handleEscapeKey(e) {
      e.key === "Escape" && (this.isNavOpen && this.activeSubNavItem ? this.activeSubNavItem = null : this.close());
    },
    setActiveNavItem(e) {
      this.activeSubNavItem = e;
    }
  }
}, G = ["aria-expanded", "aria-label", "data-track-component-name", "data-track-id", "data-track-text"], U = ["aria-label"], J = ["aria-label"], Q = ["data-track-component-name", "data-track-text", "onClick"], X = {
  key: 0,
  class: "ds-header-vertical-navigation__items__item ds-padding-top-24 ds-padding-bottom-12",
  role: "none"
}, Y = ["aria-expanded", "data-track-component-name", "data-track-id", "data-track-text"], Z = { class: "ds-header-vertical-navigation__search" }, ee = { class: "ds-container ds-padding-y-48 ds-height-full" }, te = {
  key: 1,
  class: "ds-header-vertical-navigation__items__item ds-padding-y-12",
  role: "none"
}, ae = {
  key: 2,
  class: "ds-header-vertical-navigation__items__item ds-padding-bottom-12"
};
function ne(e, o, a, b, v, n) {
  const w = c("DsHeaderNavigationIcon"), D = c("DsIconCore"), C = c("DsHeaderSubnavigationVertical"), u = c("DsHeaderNavigationVerticalSlideOver"), g = c("DsLink"), S = c("DsTextIconElement"), O = P("click-outside-awds");
  return N((i(), s("div", {
    tabindex: "-1",
    class: "ds-display-flex ds-justify-content-flex-end ds-justify-align-items-center",
    onKeydown: o[3] || (o[3] = T((...t) => n.handleEscapeKey && n.handleEscapeKey(...t), ["esc"]))
  }, [
    l("button", {
      type: "button",
      "aria-haspopup": "true",
      "aria-controls": "navigation",
      "aria-expanded": e.isNavOpen.toString(),
      "aria-label": e.isNavOpen ? a.labels.ariaLabelCloseNavigation : a.labels.ariaLabelOpenNavigation,
      class: _(["ds-header-vertical-navigation-button ds-button-link ds-button-link--primary", n.headerNavigationButtonClassName]),
      "data-track-component-name": e.trackingDataProvided["component-name"] || e.$options.name,
      "data-track-id": e.$options.tracking.id.NAVIGATION_MENU,
      "data-track-text": e.isNavOpen ? a.labels.ariaLabelCloseNavigation : a.labels.ariaLabelOpenNavigation,
      "data-track-level": "1",
      onClick: o[0] || (o[0] = (...t) => n.toggleNav && n.toggleNav(...t))
    }, [
      d(w, { active: e.isNavOpen }, null, 8, ["active"])
    ], 10, G),
    N(d(u, { "with-shadow": "" }, {
      default: p(() => [
        l("nav", {
          id: "navigation",
          "aria-label": a.labels.ariaLabelNavigation,
          class: "ds-header-vertical-navigation"
        }, [
          l("ul", {
            "aria-label": a.labels.ariaLabelNavigation,
            class: "ds-header-vertical-navigation__items",
            role: "menubar"
          }, [
            (i(!0), s(h, null, f(a.primaryItems, (t, r) => (i(), s("li", {
              key: `primary_${r}`,
              class: _(["ds-header-vertical-navigation__items__item ds-background-color-white ds-padding-y-12", [
                { "ds-padding-top-24": r === 0 },
                { "ds-padding-bottom-24": r === a.primaryItems.length - 1 },
                { "ds-padding-y-12": r > 0 && r < a.primaryItems.length - 1 }
              ]]),
              role: "none"
            }, [
              t.items ? (i(), s(h, { key: 0 }, [
                l("button", {
                  type: "button",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  class: "ds-button-link ds-button-link--primary ds-button-link--black ds-header-vertical-navigation__link",
                  role: "menuitem",
                  "data-track-component-name": e.trackingDataProvided["component-name"] || e.$options.name,
                  "data-track-text": t.title,
                  "data-track-level": "1",
                  onClick: (L) => n.setActiveNavItem(t.id)
                }, [
                  l("span", null, j(t.title), 1),
                  d(D, {
                    category: "arrows",
                    name: "chevron-right"
                  })
                ], 8, Q),
                e.activeSubNavItem === t.id ? (i(), k(u, { key: 0 }, {
                  default: p(() => [
                    d(C, B({ ref_for: !0 }, t, {
                      onClosed: o[1] || (o[1] = (L) => n.setActiveNavItem(null)),
                      onLinkClicked: n.toggleNav
                    }), null, 16, ["onLinkClicked"])
                  ]),
                  _: 2
                }, 1024)) : m("", !0)
              ], 64)) : (i(), k(g, {
                key: 1,
                "tracking-data": { "component-name": e.$options.name, text: t.title, level: 1, ...e.trackingDataProvided },
                url: t.url,
                "open-in-new-window": t.openInNewWindow,
                nuxt: t.nuxt,
                content: t.title,
                color: "black",
                class: "ds-header-vertical-navigation__link",
                role: "menuitem",
                onClick: n.toggleNav
              }, null, 8, ["tracking-data", "url", "open-in-new-window", "nuxt", "content", "onClick"]))
            ], 2))), 128)),
            e.$slots.search ? (i(), s("li", X, [
              l("button", {
                type: "button",
                "aria-haspopup": "true",
                role: "menuitem",
                class: "ds-button-link ds-button-link--primary ds-button-link--black",
                "aria-expanded": (e.activeSubNavItem === e.$options.searchItemId).toString(),
                "data-track-component-name": e.trackingDataProvided["component-name"] || e.$options.name,
                "data-track-id": e.$options.tracking.id.SEARCH,
                "data-track-text": a.labels.searchLabel,
                "data-track-level": "1",
                onClick: o[2] || (o[2] = (t) => n.setActiveNavItem(e.$options.searchItemId))
              }, [
                d(S, {
                  text: a.labels.searchLabel,
                  "icon-left": { category: "interface", name: "search" },
                  "with-spacing": ""
                }, null, 8, ["text"])
              ], 8, Y),
              e.activeSubNavItem === e.$options.searchItemId ? (i(), k(u, {
                key: 0,
                "width-full": ""
              }, {
                default: p(() => [
                  l("div", Z, [
                    l("div", ee, [
                      I(e.$slots, "search")
                    ])
                  ])
                ]),
                _: 3
              })) : m("", !0)
            ])) : m("", !0),
            (i(!0), s(h, null, f(a.secondaryItems, (t, r) => (i(), s("li", {
              key: `secondary_${r}`,
              class: "ds-header-vertical-navigation__items__item ds-padding-y-12",
              role: "none"
            }, [
              d(g, {
                "tracking-data": { "component-name": e.$options.name, text: t.title, level: 1, ...e.trackingDataProvided },
                url: t.url,
                "icon-left": t.icon,
                "open-in-new-window": t.openInNewWindow,
                nuxt: t.nuxt,
                content: t.title,
                color: "black",
                class: "ds-header-navigation__link",
                role: "menuitem",
                onClick: n.toggleNav
              }, null, 8, ["tracking-data", "url", "icon-left", "open-in-new-window", "nuxt", "content", "onClick"])
            ]))), 128)),
            a.ctaItem ? (i(), s("li", te, [
              d(g, {
                "tracking-data": { "component-name": e.$options.name, text: a.ctaItem.title, level: 1, ...e.trackingDataProvided },
                role: "menuitem",
                url: a.ctaItem.url,
                "open-in-new-window": a.ctaItem.openInNewWindow,
                nuxt: a.ctaItem.nuxt,
                content: a.ctaItem.title,
                class: "ds-width-full ds-justify-content-center",
                type: "button",
                onClick: n.toggleNav
              }, null, 8, ["tracking-data", "url", "open-in-new-window", "nuxt", "content", "onClick"])
            ])) : m("", !0),
            e.$slots["locale-switcher"] ? (i(), s("li", ae, [
              I(e.$slots, "locale-switcher", { theme: e.theme })
            ])) : m("", !0)
          ], 8, J)
        ], 8, U)
      ]),
      _: 3
    }, 512), [
      [K, e.isNavOpen]
    ])
  ], 32)), [
    [O, n.close]
  ]);
}
const ke = /* @__PURE__ */ x(F, [["render", ne]]);
export {
  ke as default
};
